import { PAGE_SIZES, STATUS } from "../constants/status";

export class ServiceQueryFetcher {
  key_search: string = "";
  page: number = 1;
  limit: number = PAGE_SIZES[0];
  status: number = STATUS.ACTIVE
}